import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';



export default class testimonials {
    constructor() {
        this.state = {};
    }

    init() {
        const swiper = new Swiper('.swiper', {
            modules: [Navigation, Pagination, Autoplay],
            autoplay: {
                delay: 3000
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            loop: true
        });

        const ioFadeIn = document.querySelectorAll(".js-io-fade-in");
        if ("IntersectionObserver" in window) {
            ioFadeIn.forEach((el) => {
                el.style.opacity = 0;
            });
            const ioObserver = new IntersectionObserver(
                function (entries, observer) {
                    entries.forEach(function (el) {
                        if (el.isIntersecting) {
                            const item = el.target;
                            item.style.opacity = 1;
                            ioObserver.unobserve(item);
                        }
                    });
                },
                {
                    rootMargin: "0px",
                    threshold: 1.0
                }
            );

            ioFadeIn.forEach(function (el) {
                ioObserver.observe(el);
            });
        }
    }
}

  